const region = "/za";

export const internalLinks = Object.freeze({
  HOME: `${region}/`,
  ABOUT: `${region}/about`,
  PRESS: `${region}/press`,
  CAREERS: `${region}/careers`,
  STORIES: `${region}/stories`,
  DEMOS: `${region}/demos`, // Deprecated route.
  JHB_DEMO: `${region}/demos/jhb-demos`,
  CPT_DEMO: `${region}/demos/cpt-demos`,
  YOCO_STORE: `${region}/yoco-store`,
  LOGIN: "https://portal.yoco.co.za",
  CREATE_ACCOUNT_V1: `/create-account/v1`,
  CREDIT_CARD_READERS: `${region}/credit-card-readers`,
  TRANSACTION_FEES: `${region}/transaction-fees`,
  POINT_OF_SALE: `${region}/point-of-sale-app`,
  BUSINESS_PORTAL: `${region}/portal`,
  INTEGRATIONS: `${region}/integrations`,
  PRIVACY_AND_APP_POLICY: `${region}/terms/privacy-and-app`,
  MERCHANT_AGREEMENT_POLICY: `/merchant-agreement.pdf`,
  VOUCHER_TERMS: `/yoco_voucher_terms_and_conditions.pdf`,
  REFERRAL_PROGRAM_AND_PROMOTIONS_POLICY: `/yoco_referral_promotions.pdf`,
  READER_POLICIES: `${region}/terms/reader-policies`,
  YO_UPGRADE_TERMS: `${region}/terms/yoUpgrade-terms`,
  ACQUIRING_FAQS: `${region}/terms/acquiring-faqs`,
  PROHIBITED_BUSINESSES: `${region}/terms/prohibited-businesses`,
  MARCH_MADNESS_TERMS: `${region}/terms/march-madness`,
  TERMS_INDEX: `${region}/terms`,
  CONTACT_PAGE: `${region}/contact`
});

export const externalLinks = Object.freeze({
  READER_CARE:
    "https://get.yoco.help/hc/en-za/articles/115006012369-Caring-for-your-Wireless-Card-Reader",
  FAQ: "https://get.yoco.help/hc/en-za",
  MAP_CPT:
    "https://maps.google.com/maps?ll=-33.92205,18.41985&z=14&t=m&hl=en-US&gl=ZA&mapclient=embed&cid=14582264318219888113",
  MAP_JHB:
    "https://maps.google.com/maps?ll=-26.139557,28.017546&z=14&t=m&hl=en-US&gl=US&mapclient=embed&cid=10322663077063001222",
  PROMO_CARD_MACHINES: "https://promo.yoco.co.za/card-machines",
  JUST_START: "https://yoco.co.za/juststart",
  YOCO_STORE_MAPS_ADDRESS:
    "https://maps.google.com/maps?ll=-26.139557,28.017546&z=14&t=m&hl=en-US&gl=US&mapclient=embed&cid=10322663077063001222",
  ACCESSORIES: "https://yoco.store/",
  REFERRALS: "https://promo.yoco.co.za/referrals",
  DEVELOPERS: "https://developer.yoco.com/ios-sdk/"
});

export default Object.freeze({
  ...internalLinks,
  ...externalLinks
});



// WEBPACK FOOTER //
// ./src/libs/pageLinks.js